export enum UserRoleType {
  None = 0,
  Platform = 1,
  Company = 2,
  Location = 4
}
